
export default class Mixin{

    constructor () {
    }

    sayMix () {
        console.debug('sayMix')
    }
}